import React, { useEffect } from 'react'
import { ScrollView } from 'react-native'

import { STEP_CONST } from '@constants/demoSaleApplication/constant'
import { DemoSellAlert } from '@zet/common/components/demoSellAlert'
import { Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { LeadStatus } from '@zet/utils/Constants'

import { useGetDemoLeadDetails } from '../../../../api/webflow/demoSale/hooks'
import { useDemoSaleApplicationState } from '../../../../store/demoSaleApplicationState'
import Header from './header'
import { LeadFulFilledBanner } from './leadFulFilledBanner'
import Steps from './steps'

const LeadApplicationStatus = () => {
  const { currentState, setCurrentState } = useDemoSaleApplicationState(
    (state) => state
  )
  const { data } = useGetDemoLeadDetails()

  useEffect(() => {
    if (data) {
      if (data?.leadDetails?.status === LeadStatus.FULLFILLED) {
        setCurrentState(STEP_CONST.LEAD_FULFILLED)
      } else if (data?.leadDetails?.status === LeadStatus.ACTION_REQUIRED) {
        setCurrentState(STEP_CONST.EKYC)
      } else {
        setCurrentState(STEP_CONST.APPLICATION_FORM)
      }
    }
  }, [data])

  return (
    <Stack className="flex-1 bg-white">
      <ScrollView showsVerticalScrollIndicator={false}>
        <DemoSellAlert
          content={i18n.t('demoSale.warning.saleProcess')}
        ></DemoSellAlert>
        <Header />
        {currentState === STEP_CONST.LEAD_FULFILLED && <LeadFulFilledBanner />}
        <Steps currentStep={currentState} />
      </ScrollView>
    </Stack>
  )
}

export default LeadApplicationStatus
